<fieldset [formGroup]="group" class="in-two-columns">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>

  <!-- type -->

  <mat-form-field>
    <app-easy-select
      formControlName="type"
      [label]="TITLE + 'VODKA_TYPE' | translate"
      [translatePrefixForSelected]="'PRODUCTS.VODKA_TYPE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="types | toSelectOption: 'PRODUCTS.VODKA_TYPE.'"
      (ngModelChange)="onTypeChange($event)"
    >
    </app-easy-select>
  </mat-form-field>

  <!-- flavorTypes -->

  <mat-form-field *ngIf="isFlavored">
    <app-easy-select
      formControlName="flavorTypes"
      [label]="TITLE + 'FLAVOR_TYPES' | translate"
      [translatePrefixForSelected]="'PRODUCTS.FLAVOR_TYPE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [multiple]="true"
      [options]="flavorType | toSelectOption: 'PRODUCTS.FLAVOR_TYPE.':true"
    >
    </app-easy-select>
  </mat-form-field>
</fieldset>
